var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informationLayout",on:{"contextmenu":function($event){return _vm.$emit('contextmenu', $event)}}},[_c('h2',[_vm._v("동아리 소개")]),_c('p',[_vm._v(_vm._s(_vm.getClub.introduction))])])}
var staticRenderFns = []

export { render, staticRenderFns }